module.exports = __webpack_public_path__ + "img/10_diamonds_star.82b0b016.png";